import { isOfType } from '../helpers'

export const domainTypesArr = ['TWT', 'Z', 'ANY'] as const

export type DomainType = (typeof domainTypesArr)[number]

export type CommonDomainType = Extract<DomainType, 'Z' | 'TWT'> // 'Depth' | 'Time' | 'Speed' | 'Other'
export const isDomainType = isOfType(domainTypesArr)
